let _k_copyCapExWindow = null;

export default function() {
    createWindow();
    attachWindowEvents();
}

function createWindow() {
    if (_k_copyCapExWindow !== null) return;

    const $window = $('#cap-ex-copy-window');
    if (!$window.length) {
        return;
    }

    _k_copyCapExWindow = $window.kendoWindow({
        title: 'Copy Previous CapEx',
        visible: false,
        actions: [
            'Close',
        ],
        close: onWindowClose,
        open: onWindowOpen,
        // width: '90%',
        // height: '90%',
        maxWidth: 1080,
        maxHeight: 800,
        draggable: false,
    }).data('kendoWindow').center();

    attachCopyConfirmEvent();
    attachCopyCancelEvent();
}

function attachCopyConfirmEvent() {
    const $confirmCopyButton = $('.js-confirm-copy');

    $confirmCopyButton.unbind('click');
    $confirmCopyButton.bind('click', function(data) {
        const selectedItem = $('input.js-previous-cap-ex-list').data('kendoAutoComplete').dataItem();

        if (selectedItem) {
            copyCapEx(selectedItem.RequestNumber)
                .then(_ => _k_copyCapExWindow.close());
        }
    });
}

function attachCopyCancelEvent() {
    const $confirmCopyButton = $('.js-cancel-copy');

    $confirmCopyButton.unbind('click');
    $confirmCopyButton.bind('click', function() {
        _k_copyCapExWindow.close();
    });
}

function onWindowOpen() {
}

function onWindowClose() {
    $('input.js-previous-cap-ex-list').data('kendoAutoComplete').value('');
}

function attachWindowEvents() {
    attachOpenWindowEvent();
}

function attachOpenWindowEvent() {
    const $copyRequestButton = $('#copy-cap-ex');
    if (!$copyRequestButton.length) {
        return;
    }

    $copyRequestButton.unbind('click');
    $copyRequestButton.bind('click', function(e) {
        e.preventDefault();
        _k_copyCapExWindow.open();
    });
}

function copyCapEx(capExId) {
    return new Promise((resolve) => {
        $.post('/Finance/CapExTechnologyRequest/CopyCapitalExpenditures', { capExId }, (response) => {
            setValues(response);
            resolve();
        });
    });
}

function setValues(capExRequest) {
    $.each(capExRequest, (i, e) => {
        switch (i) {
            case 'BasedPrice' :
                i = 'BasePrice';
                break;
            case 'SpecialHardwareRequest' :
                i = 'SpecialHardwareRequirements';
                break;
            case 'SpecialSoftwareRequest' :
                i = 'SpecialSoftwareRequirements';
                break;

            default:
                break;
        }

        let $field = $(`[name=${i}]`);
        if ($field.data('kendoDropDownList')) {
            $field.data('kendoDropDownList').value(e);
        } else if ($field.data('kendoDatePicker')) {
            $field.data('kendoDatePicker').value(e);
        } else if ($field.data('kendoAutoComplete')) {
            $field.data('kendoAutoComplete').value(e);
        } else if ($field.data('kendoNumericTextBox')) {
            $field.data('kendoNumericTextBox').value(e);
            $field.trigger('change');
        } else if ($field.hasClass('k-textbox')) {
            $field.val(e);
            $field.trigger('keyup');
        } else {

        }

    });

    $('[name="RequesterContact.MailingAddress"]').val(capExRequest.RequesterAddress);
    $('[name="RequesterContact.MailingCity"]').val(capExRequest.RequesterCity);
    $('[name="RequesterContact.MailingState"]').data('kendoDropDownList').value(capExRequest.RequesterState);
    $('[name="RequesterContact.MailingZip"]').val(capExRequest.RequesterZip);
    $('[name="RequesterContact.Phone"]').val(capExRequest.RequesterPhone);
}
